import { useEffect, useState } from "react";
import {
  CompetitionTournamentResponse,
  getRunnerCompetitionTournamentById,
} from "../../../../../../api/runner-competition-tournament";
import { calculateTimes } from "../../../../../../utils/timer";

export const useRabbitFestivalEvent = () => {
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState<CompetitionTournamentResponse | null>(
    null
  );
  const [eventId, setEventId] = useState<number>(0);

  const getEvent = async () => {
    if (!eventId) return;
    setLoading(true);
    try {
      const res = await getRunnerCompetitionTournamentById(eventId);
      if (res.tournament.timerDto) {
        const time = calculateTimes(
          res.tournament.timerDto,
          res.tournament.structure,
          true
        );
        if (time && time.overStack < 1) {
          res.tournament.timeInfo = time;
        }
      }
      setEvent(res);
      setTimeout(() => {
        setLoading(false);
      }, 50);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getEvent();
  }, [eventId]);

  return {
    eventId,
    setEventId,
    event,
    setEvent,
    loading,
    getEvent,
  };
};
